import React, { useState } from 'react'
import { Button, Dropdown, DropdownButton, Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import MoreHorizSharpIcon from '@mui/icons-material/MoreHorizSharp';
import SearchSharpIcon from '@mui/icons-material/SearchSharp';


const manageapp = [
  {
    name: "Design Engineer",
    job: "Quality Engineer",
    day: "day left",
    company: "Shivam Electricals Pvt Ltd",
    applyDate: "Sep 28, 2023",
    avatar: "https://via.placeholder.com/50",
  },
  {
    name: "Design Engineer",
    job: "Quality Engineer",
    day: "day left",
    company: "Shivam Electricals Pvt Ltd",
    applyDate: "Sep 28, 2023",
    avatar: "https://via.placeholder.com/50",
  },
  {
    name: "Design Engineer",
    job: "Quality Engineer",
    day: "day left",
    company: "Shivam Electricals Pvt Ltd",
    applyDate: "Sep 28, 2023",
    avatar: "https://via.placeholder.com/50",
  },
  {
    name: "Design Engineer",
    job: "Quality Engineer",
    day: "day left",
    company: "Shivam Electricals Pvt Ltd",
    applyDate: "Sep 28, 2023",
    avatar: "https://via.placeholder.com/50",
  },
  {
    name: "Design Engineer",
    job: "Quality Engineer",
    day: "day left",
    company: "Shivam Electricals Pvt Ltd",
    applyDate: "Sep 28, 2023",
    avatar: "https://via.placeholder.com/50",
  },

];


const ManageApp = () => {

  return (
    <>

      <section className="pricing-section-three container jobapplication pt-5">
        <div className="row">
          <div className="mb-1 col-6">
            <h4 className="orange-title">
              <span className="orange-box me-2"></span>
              Jobs  Application </h4>
          </div>
          <div className="mb-1 col-6 text-start">
            <h4 className="  d-flex justify-content-end">
              <Link to={"/Interviews"}>
                Interviews
              </Link>
            </h4>
          </div>
        </div>
        <div className="container st3">
          <div className="row">
            <div className="col-lg-12">

              <div class="wd-findjob-filer">
                <div class="group-select">
                  <div class="Dropdown-root react-dropdown sort-buy sort-search  mb-2">
                    <div class="Dropdown-control search-container" aria-haspopup="listbox">
                      <SearchSharpIcon className="icons" />
                      <input
                        type="text"
                        class="search-input"
                        placeholder="Search..."
                        aria-label="Search"
                      />
                    </div>
                  </div>
                </div>
                <div class="group-select">
                  {/* <div class="Dropdown-root react-dropdown sort sort-buy mb-2">
                    <div class="Dropdown-control sort" aria-haspopup="listbox">
                      <div class="Dropdown-placeholder is-selected">
                        Sort by Default....
                      </div>
                      <div class="Dropdown-arrow-wrapper">
                        <span class="Dropdown-arrow"></span>
                      </div>
                    </div>
                  </div> */}
                  <div className="Dropdown-root react-dropdown sort sort-buy mb-2">
                    <Dropdown>
                      <Dropdown.Toggle as="div" className="Dropdown-control sort" aria-haspopup="listbox">
                        <div className="Dropdown-placeholder is-selected">
                          Sort by Default...
                        </div>
                        <div className="Dropdown-arrow-wrapper">
                          <span className="Dropdown-arrow"></span>
                        </div>
                      </Dropdown.Toggle>

                      <Dropdown.Menu>
                        <Dropdown.Item href="#/action-1">View Job</Dropdown.Item>
                        <Dropdown.Item href="#/action-2">Remove Job</Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </div>
              </div>
              <div className="table-res">
                <table className="notification-table">
                  <thead>
                    <tr>
                      <th className="ps-5">Jobs</th>
                      <th>Categories</th>
                      <th>Date Post</th>
                      {/* <th>Recent Works</th> */}
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {manageapp.map((item, index) => (
                      <tr key={index} className='table-tr'>
                        <td>
                          <div className="candidate-info">
                            <img
                              src={item.avatar}
                              alt="avatar"
                              className="avatar"
                            />
                            <div className="row">
                              <span className="cmpnyname">{item.name}</span>
                              <div className="mt-1">
                                <span className="company">
                                  <span class="icon-map-pin me-1"></span>
                                  {item.company}</span>
                                <span className="company ms-3">
                                  <span class="icon-calendar me-1"></span>
                                  {item.day}</span>
                              </div>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div class="job-footer-left">
                            <ul class="job-tag">
                              <li>
                                <a href="/SearchJobs">Full Time</a>
                              </li>
                            </ul>
                          </div>
                        </td>
                        <td>{item.applyDate}</td>

                        <td className="actions">
                          <Dropdown>
                            <Dropdown.Toggle as="span" className="icon-toggl">
                              <MoreHorizSharpIcon className="mt-3" />
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                              <Dropdown.Item href="#/action-1">
                                View Job
                              </Dropdown.Item>
                              <Dropdown.Item href="#/action-2">
                                Remove Job
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                          {/* <button
                      className="action-button accept"
                      onClick={handleAcceptOpen}
                    >
                        ✔️
                    </button> */}
                          {/* <button
                      className="action-button reject"
                      onClick={handleRejectOpen}
                    >
                      ❌
                    </button>  */}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </section>


    </>
  )
}

export default ManageApp